<div class="loading" *ngIf="isLoading">
    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }" [appearance]="'line'">
    </ngx-skeleton-loader>
</div>

<div style="display: flex; gap: 20px;">
    <mat-card class="cardWithShadow go-back-btn" (click)="backToOrderList()">
        <tabler-icon name="arrow-left" size="24"></tabler-icon>
    </mat-card>

    <div *ngIf="order" class="client-name-container">
        <div class="profile-container">
            <div class="profile">
                <h2>{{order.data['Patient Data'].name}} {{order.data['Patient Data'].surname}}</h2>
            </div>
        </div>
    </div>
</div>

<div class="main-container" *ngIf="order">
    <aside class="sidebar">
        <div class="client-secondary-menu-placeholder">
            <div class="menu">
                <mat-card class="cardWithShadow theme-card menu-card" style="width: 115px; margin: 0;"
                    [ngClass]="{'activated': showGeneralTab}" (click)="showTab('general')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="settings" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_GENERAL' | translate }}</span>
                    </div>
                </mat-card>
                <mat-card *ngIf="hasInsolesPrescription" class="cardWithShadow theme-card menu-card"
                    style="width: 140px; margin: 0;" [ngClass]="{'activated': showPrescriptionTab}"
                    (click)="showTab('prescription')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="list-details" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_PRESCRIPTION' | translate }}</span>
                    </div>
                </mat-card>
                <mat-card *ngIf="hasOrderForm" class="cardWithShadow theme-card menu-card"
                    style="width: 140px; margin: 0;" [ngClass]="{'activated': showPrescriptionTab}"
                    (click)="showTab('prescription')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="list-details" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_ORDER_FORM' | translate }}</span>
                    </div>
                </mat-card>
                <mat-card *ngIf="this.user.sensingtexManagerId" class="cardWithShadow theme-card menu-card"
                    style="width: 150px; margin: 0;" [ngClass]="{'activated': showPressurePlateTab}"
                    (click)="showTab('pressurePlate')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="sock" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_PRESSURE_PLATE' | translate }}</span>
                    </div>
                </mat-card>
                <mat-card class="cardWithShadow theme-card menu-card" style="width: 80px; margin: 0;"
                    [ngClass]="{'activated': showFilesTab}" (click)="showTab('files')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="file-description" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_FILES' | translate }}</span>
                    </div>
                </mat-card>
                <mat-card class="cardWithShadow theme-card menu-card" style="width: 115px; margin: 0;"
                    [ngClass]="{'activated': showChargesTab}" (click)="showTab('charges')">
                    <div style="display: flex; gap: 5px; padding: 10px; justify-content: center;">
                        <i-tabler name="file-dollar" class="icon-20 d-flex"></i-tabler>
                        <span>{{ 'OD_CHARGES' | translate }}</span>
                    </div>
                </mat-card>
            </div>
        </div>
    </aside>

    <div class="loading" *ngIf="isLoading">
        <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }" [appearance]="'line'">
        </ngx-skeleton-loader>
    </div>

    <div *ngIf="showGeneralTab">
        <div class="general-tab-container">
            @for (data of order?.data | keyvalue; track data) {
            @if (data.key?.toLowerCase().trim() !== 'landmarks') {

            <!-- Caso especial: si la key es "files" -->
            @if (data.key?.toLowerCase().trim() === 'files') {
            <mat-card class="cardWithShadow general-card">
                <mat-card-content class="general-card-content">
                    <!-- Mostramos solo el value -->
                    @for (file of getKeyValuePairs(data.value); track file) {
                    <ng-container *ngIf="!isEmpty(file.value)">
                        <div class="property-item">
                            <span class="property-value">
                                {{ file.value?.name || file.value }}
                            </span>
                        </div>
                    </ng-container>
                    }
                </mat-card-content>
            </mat-card>
            } @else {
            <!-- Caso general (todo menos 'files') -->
            <mat-card class="cardWithShadow general-card">
                <mat-card-header class="general-card-header">
                    <div class="general-card-title-wrapper">
                        <mat-card-title>{{ data.key | orderDataKey }}</mat-card-title>
                        <button mat-icon-button class="edit-icon-button"
                            *ngIf="data.key?.toLowerCase().trim() === 'patient data'"
                            (click)="openUpdatePatientDataModal(data.key, data.value)">
                            <tabler-icon name="edit"></tabler-icon>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content class="general-card-content">
                    @for (property of getKeyValuePairs(data.value); track property) {
                    <ng-container *ngIf="!isEmpty(property.value)">
                        <div class="property-item">
                            <span class="property-label">{{ property.key | orderDataField }}</span>
                            <span class="property-value">
                                {{ property.value | orderDataValue }}
                            </span>
                        </div>
                    </ng-container>
                    }
                </mat-card-content>
            </mat-card>
            }

            }
            }
        </div>
    </div>

    <div class="cards-container" *ngIf="showPrescriptionTab">
        <div class="flex-container">
            <!-- Insoles Properties -->
            <mat-card *ngIf="hasInsolesPrescription" class="cardWithShadow theme-card"
                style="flex: 2;  min-width: 350px;">
                <mat-card-header>
                    <mat-card-title class="m-b-0">{{ 'OD_INSOLES_ORDER_FORM' | translate }}</mat-card-title>
                </mat-card-header>
                <mat-card-content style="height: 100%;" class="prescription-container">
                    <app-insoles-prescription style="width: 100%; max-width: 800px;"
                        [insolePrescription]="insolesPrescriptionForm"></app-insoles-prescription>
                    <button mat-raised-button color="primary" (click)="updateInsolesPrescription()"
                        [disabled]="isLoading || insolesPrescriptionForm.invalid">{{ 'UPDATE' | translate }}</button>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="formResponse" class="cardWithShadow theme-card" style="flex: 1">
                <mat-card-header class="removable-header"
                    style="display: flex; justify-content: space-between; align-items: center;">
                    <mat-card-title class="m-b-0">{{ 'OD_FORM_RESPONSE' | translate }}</mat-card-title>
                    <!-- <button mat-raised-button color="primary" (click)="downloadFormResponsePDF()">
                        <mat-icon>picture_as_pdf</mat-icon>
                        {{ 'OD_PDF' | translate }}
                    </button> -->
                </mat-card-header>
                <mat-card-content>
                    <div class="flex flex-column">
                        <div class="responses-container">
                            <ng-container *ngFor="let question of formResponse?.questions">
                                <ng-container *ngIf="question.type !== 'insolesPrescription'">
                                    <div class="response-card">
                                        <div class="card-header">
                                            <span class="question-title">{{ question.title }}</span>
                                            <span class="icon-box me-2"
                                                [ngStyle]="{ backgroundColor: questionIcons[question.type].color }">
                                                <mat-icon>{{questionIcons[question.type].icon}}</mat-icon>
                                            </span>
                                        </div>
                                        <div *ngIf="question.image" class="card-image-container">
                                            <div class="card-image-container-vertical">
                                                <img [src]="question.image" alt="image" class="card-image">
                                                <p *ngIf="question.response">{{ question.response }}</p>
                                            </div>
                                        </div>
                                        <div *ngIf="question.responses && !question.responses[0].exampleImage && question.responses[0].image && !question.image"
                                            class="card-body">
                                            <div *ngFor="let response of question.responses">
                                                <div class="card-image-container-vertical">
                                                    <img class="card-image" [src]="response.image" alt="responseImage">
                                                    <p>{{ response.responses }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Mostrar solo el texto de respuestas cuando hay question.image -->
                                        <div *ngIf="question.responses && !question.responses[0].exampleImage && question.responses[0].image && question.image"
                                            class="card-body" style="text-align: center;">
                                            <div *ngFor="let response of question.responses">
                                                <p><strong>{{ response.responses }}</strong></p>
                                            </div>
                                        </div>
                                        <div *ngIf="question.responses && question.responses[0].exampleImage"
                                            class="card-body">
                                            <div *ngFor="let response of question.responses">
                                                <div class="card-image-container-vertical">
                                                    <p><strong>{{ response.title }}</strong></p>
                                                    <img class="card-image" [src]="response.userImage"
                                                        alt="exampleImage">
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="question.response && question.type === 'dropdown'"
                                            class="card-body">
                                            <div>
                                                <p><strong>{{ question.response }}</strong></p>
                                            </div>
                                        </div>
                                        <div *ngIf="question.type === 'customComponents' && question.components"
                                            class="card-body">
                                            <div *ngFor="let component of question.components"
                                                class="custom-component-section">
                                                <h4 class="component-subtitle">{{ component.title }}</h4>
                                                <!-- numberInputWithLabels -->
                                                <div *ngIf="component.choices?.numberInputWithLabels?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.numberInputWithLabels"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.leftLabel}}</span>
                                                                <mat-chip
                                                                    class="value-chip">{{field.inputNumberValue}}</mat-chip>
                                                                <span class="field-unit">{{field.rightLabel}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- dropdownWithLabel -->
                                                <div *ngIf="component.choices?.dropdownWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.dropdownWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <mat-chip
                                                                    class="value-chip">{{field.response}}</mat-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- radioButtons -->
                                                <div *ngIf="component.choices?.radioButtons?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <ng-container
                                                            *ngFor="let field of component.choices.radioButtons">
                                                            <div *ngIf="field.response && field.response.trim() !== ''"
                                                                class="field-item">
                                                                <div class="field-content">
                                                                    <mat-chip
                                                                        class="value-chip">{{field.response}}</mat-chip>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <!-- checkboxWithLabel -->
                                                <div *ngIf="component.choices?.checkboxWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.checkboxWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <mat-chip class="value-chip">{{field.checked ? 'Yes' :
                                                                    'No'}}</mat-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- multipleCheckboxWithLabel -->
                                                <div *ngIf="component.choices?.multipleCheckboxWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.multipleCheckboxWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <mat-chip class="value-chip">{{field.responses?.join(',
                                                                    ')}}</mat-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="question.response && question.type !== 'dropdown' && question.type !== 'customComponents'"
                                            class="card-body">
                                            <div>
                                                <p><strong>{{ question.response }}</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div *ngIf="questionsWithComponents.length > 0" class="components-grid">
                            <ng-container *ngFor="let question of questionsWithComponents">
                                <ng-container
                                    *ngIf="question.type !== 'customComponents' && question.type !== 'insolesPrescription'">
                                    <mat-card *ngFor="let component of question.components"
                                        class="cardWithShadow component-card">
                                        <mat-card-header>
                                            <div class="component-card-header">
                                                <mat-card-title class="component-title">{{ component.title
                                                    }}</mat-card-title>
                                                <span class="icon-box"
                                                    [ngStyle]="{ backgroundColor: questionIcons[question.type].color }">
                                                    <mat-icon>{{ questionIcons[question.type].icon }}</mat-icon>
                                                </span>
                                            </div>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <div class="card-body">

                                                <!-- numberInputWithLabels -->
                                                <div *ngIf="component.choices.numberInputWithLabels?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.numberInputWithLabels"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.leftLabel}}</span>
                                                                <mat-chip
                                                                    class="value-chip">{{field.inputNumberValue}}</mat-chip>
                                                                <span class="field-unit">{{field.rightLabel}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- dropdownWithLabel -->
                                                <div *ngIf="component.choices.dropdownWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.dropdownWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <mat-chip
                                                                    class="value-chip">{{field.response}}</mat-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- checkboxWithLabel -->
                                                <div *ngIf="component.choices.checkboxWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.checkboxWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <div class="checkbox-options">
                                                                    <mat-chip
                                                                        *ngFor="let opt of field.options; let idx=index"
                                                                        [class]="field.values[idx] ? 'value-chip checked' : 'value-chip unchecked'">
                                                                        <mat-icon *ngIf="field.values[idx]"
                                                                            class="check-icon">check</mat-icon>
                                                                        {{opt}}
                                                                    </mat-chip>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- multipleCheckboxWithLabel -->
                                                <div *ngIf="component.choices.multipleCheckboxWithLabel?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.multipleCheckboxWithLabel"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.label}}</span>
                                                                <div class="checkbox-options">
                                                                    <mat-chip *ngFor="let response of field.responses"
                                                                        class="value-chip">
                                                                        {{response}}
                                                                    </mat-chip>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- radioButtons -->
                                                <div *ngIf="component.choices.radioButtons?.length"
                                                    class="field-section">
                                                    <div class="field-items">
                                                        <div *ngFor="let field of component.choices.radioButtons"
                                                            class="field-item">
                                                            <div class="field-content">
                                                                <span class="field-label">{{field.response}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Imagen -->
                                                <div class="text-center mt-2" *ngIf="component.image">
                                                    <img [src]="component.image" class="img-fluid rounded"
                                                        style="max-height: 150px;">
                                                </div>

                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="cards-container" *ngIf="showPressurePlateTab">
        <!-- Pressure Plate Card -->
        <mat-card *ngIf="this.user.sensingtexManagerId" class="cardWithShadow theme-card"
            style="width: 100%; height: fit-content;">
            <mat-card-header class="p-3">
                <div class="card-header">
                    <div class="pressures-title">
                        <mat-card-title>{{ 'PRESSURE_PLATE_ANALYSES' | translate }}</mat-card-title>
                        <button type="button" mat-raised-button color="primary" (click)="startAnalysis()">{{
                            'NEW_ANALYSIS' | translate }}</button>
                    </div>
                    <div class="generate-details-pdf">
                        <div class="flex-column">
                            <div class="badges">
                                <span class="btn features-button btn-circle btn-md">{{ premiumUser ? ('PRO_PLAN' |
                                    translate) : ('BASIC_PLAN' | translate) }}</span>
                                <button *ngIf="!premiumUser" type="button" mat-raised-button color="primary"
                                    (click)="openUpgradeModal()">{{ 'UPGRADE' | translate }}</button>
                                <app-modal-pro-features [(visible)]="upgradeModalVisible"
                                    (subscriptionSuccess)="enablePremium()"></app-modal-pro-features>
                            </div>
                            <div *ngIf="premiumUser && patientAnalyses && patientAnalyses.length > 0"
                                class="d-flex align-items-center" style="gap: 10px;">
                                <span>{{ 'ANALYSES_DETAILS_REPORT' | translate }}</span>
                                <button mat-raised-button type="button" class="pdf-special-button"
                                    (click)="showPDFDetails()">
                                    <i class="pi pi-file-pdf"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-header>

            <!-- <div class="row p-2 justify-content-center" *ngIf="isLoading">
             <div class="spinner-grow text-primary" role="status">
                 <span class="sr-only">Loading...</span>
             </div>
         </div> -->
            <div class="d-flex justify-content-center" *ngIf="isLoading">
                <div class="skeleton-card is-loading">
                    <div class="image"></div>
                    <div class="content">
                        <h2></h2>
                        <p></p>
                        <div class="d-flex justify-content-end w-100">
                            <h2></h2>
                        </div>
                    </div>
                </div>
            </div>


            <mat-card-content *ngIf="order?.sensingtexPatientId" class="p-3">
                <div class="analyses-container">
                    <ng-container *ngIf="patientAnalyses && patientAnalyses.length > 0; else noAnalyses">
                        <div *ngFor="let patientAnalysis of patientAnalyses">
                            <div class="mini-card">
                                <div (click)="goToAnalysisDetails(orderId, patientAnalysis.id)">
                                    <div class="analysis-card-body-top">
                                        <app-analysis [showActions]="false" [analysis]="patientAnalysis"></app-analysis>
                                    </div>
                                    <div class="analysis-card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 width-120 badge">
                                            <strong>{{
                                                'ANALYSIS_TYPE.' + patientAnalysis.type | translate }}</strong>
                                        </h5>
                                        <h5 class="m-3"> {{ patientAnalysis.creationDate }}</h5>
                                    </div>
                                </div>
                                <div class="delete-button-container">
                                    <button type="button" class="delete-button"
                                        (click)="deleteAnalysis(patientAnalysis.id)"><strong>{{ 'OD_REMOVE' | translate
                                            }} </strong></button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noAnalyses>
                        <div class="mb-3">{{ isLoading ? 'Searching analyses...' : 'No analyses found.' }}</div>
                    </ng-template>
                </div>
            </mat-card-content>

            <p-dialog header="{{ 'SELECT_ANALYSIS_TYPE' | translate }}" [(visible)]="visible"
                [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}" [modal]="true">
                <div *ngIf="connectedPlatform"
                    style="display: flex; justify-content: center; gap: 7px; align-items: baseline; margin-bottom: 15px;">
                    <p><strong>{{ 'CONNECTED_PLATFORM' | translate }}</strong>
                    </p>
                    <i class="pi pi-check-circle" style="color: green;"></i>
                </div>
                <div *ngIf="!connectedPlatform"
                    style="display: flex; justify-content: center; gap: 7px; align-items: baseline; margin-bottom: 15px;">
                    <p><strong>{{ 'PLATFORM_NOT_CONNECTED' | translate }}</strong>
                    </p>
                    <i class="pi pi-times" style="color: red;"></i>
                </div>
                <div class="flex-buttons">
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openStaticModal()">{{
                        'STATIC' | translate }}</button>
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openDynamicModal()">{{
                        'DYNAMIC' | translate }}</button>
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openBalanceModal()">{{
                        'BALANCE' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'STATIC_ANALYSIS_STEPS' | translate }}" [(visible)]="staticModalVisible" [modal]="true"
                [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/StaticAndBalanceAnalysis.png'" alt="static-analysis">
                    <h4>{{ 'STEP_ONE_STATIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_STATIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('static')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'DYNAMIC_ANALYSIS_STEPS' | translate }}" [(visible)]="dynamicModalVisible"
                [modal]="true" [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/DynamicAnalysis.gif'" alt="dynamic-analysis"
                        style="max-width: 200px;">
                    <h4>{{ 'STEP_ONE_DYNAMIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_DYNAMIC' | translate }}</h4>
                    <h4>{{ 'STEP_THREE_DYNAMIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('dynamic')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'BALANCE_ANALYSIS_STEPS' | translate }}" [(visible)]="balanceModalVisible"
                [modal]="true" [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/StaticAndBalanceAnalysis.png'" alt="balance-analysis">
                    <h4>{{ 'STEP_ONE_STATIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_STATIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('balance')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>

        </mat-card>
    </div>

    <div *ngIf="showFilesTab">
        <div class="flex-container" style="height: fit-content;">
            <!-- Files -->
            <app-files style="width: 100%;"></app-files>

            <!-- Images -->
            <mat-card *ngIf="order?.imageFilesAccount > 0" class="cardWithShadow theme-card"
                style="flex: 1; min-width: 350px;">
                <mat-card-header>
                    <mat-card-title class="m-b-0">{{ 'OD_IMAGES_CARD' | translate }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="col-md-12" *ngIf="order?.imageFilesAccount > 0">
                        <div class="row el-element-overlay">
                            <div class="col-lg-3 col-md-6" *ngFor="let file of order.files | filterByImageType">
                                <div class="card">
                                    <div class="el-card-item">
                                        <div class="el-card-avatar el-overlay-1">
                                            <!-- Imagen en miniatura -->
                                            <img src="{{file.path}}" alt="{{file.name}}" class="thumbnail"
                                                (click)="openImageDialog(file)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card *ngIf="order?.pdfFilesAccount > 0" class="cardWithShadow theme-card" style="flex: 1">
                <mat-card-header>
                    <mat-card-title class="m-b-0">{{ 'OD_PDF_PREVIEW' | translate }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="col-md-12">
                        <div class="el-element-overlay">
                            <div *ngFor="let file of order.files" class="pdf-container">
                                <ng-container *ngIf="file?.type === 'pdf'">
                                    <div [id]="'adobe-dc-view-' + file.name"
                                        style="width: 100%; height: 700px; margin-bottom: 30px;"></div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Modal de visualización de la imagen -->
            <ng-template #imageDialog let-data>
                <div mat-dialog-title style="display: flex; justify-content: space-between; padding-top: 30px;">
                    <span>{{ data?.name }}</span>
                    <button mat-icon-button mat-dialog-close aria-label="Close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <div mat-dialog-content class="image-dialog">
                    <img [src]="data?.path" alt="{{ data?.name }}" class="full-image" />
                </div>
            </ng-template>

            <!-- Videos -->
            <mat-card *ngIf="videoSafeUrl" class="cardWithShadow theme-card" style="flex: 1;  min-width: 350px;">
                <mat-card-header>
                    <mat-card-title class="m-b-0">{{ 'OD_VIDEOS' | translate }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="col-md-12" *ngIf="videoSafeUrl">
                        <div class="card rounded-5">
                            <div class="card-body">
                                <div class="card-body">
                                    <div class="embed-responsive embed-responsive-16by9">
                                        <video class="embed-responsive-item" [src]="videoSafeUrl" controls></video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div *ngIf="showChargesTab">
        <!-- Charges Card -->
        <mat-card class="cardWithShadow theme-card" style="width: 100%; height: fit-content;">
            <mat-card-header>
                <mat-card-title class="m-b-0">{{ 'OD_CHARGES_LIST' | translate }}</mat-card-title>
            </mat-card-header>

            <mat-card-content style="display: flex; justify-content: center;">
                <table mat-table [dataSource]="orderRecord" *ngIf="orderRecord">

                    <!-- Type Column -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell style="font-weight: bold;" *matHeaderCellDef> {{ 'OD_TYPE' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionType}} </td>
                    </ng-container>

                    <!-- Charged Column -->
                    <ng-container matColumnDef="chargedTo">
                        <th mat-header-cell style="font-weight: bold;" *matHeaderCellDef> {{ 'OD_CHARGED' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.chargedTo}} </td>
                    </ng-container>

                    <!-- File Column -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell style="font-weight: bold;" *matHeaderCellDef> {{ 'OD_CREATED' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.createdAt | date:'dd/MM/yyyy HH:mm' }} </td>

                    </ng-container>

                    <!-- Table Header and Rows -->
                    <thead>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    </thead>
                    <tbody>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </tbody>
                </table>
                <div style="display: flex; flex-direction: column; align-items: center;" *ngIf="!orderRecord">
                    <img style="margin-bottom: 15px;" src="assets/images/svgs/factura.png" alt="factura" width="80"
                        height="80">
                    <span>{{ 'OD_NO_CHARGES' | translate }}</span>
                </div>

            </mat-card-content>
        </mat-card>
    </div>

</div>

<p-dialog header="{{ 'OD_EDIT_INFO' | translate }}" [(visible)]="showEditPatientDataModal" [modal]="true"
    [closable]="true" [style]="{ width: '400px' }">
    <form *ngIf="editForm" [formGroup]="editForm" (ngSubmit)="savePatientData()" class="p-fluid">
        <div *ngFor="let field of editableFields" class="p-field form-field-spacing">
            <label for="{{ field.key }}" class="p-d-block p-mb-1 text-capitalize">{{ field.key | orderDataField
                }}</label>
            <input pInputText [formControlName]="field.key" id="{{ field.key }}" class="p-inputtext-sm"
                [placeholder]="getFieldPlaceholder(field.key)" />
        </div>

        <div class="p-d-flex p-jc-end m-t-22">
            <button type="submit" pButton label="{{ 'OD_SAVE' | translate }}" class="p-button-primary"
                [disabled]="editForm.invalid || isLoading"></button>
        </div>
    </form>
</p-dialog>

<!-- <div class="flex-container">
    <mat-card *ngIf="videoUrl" class="cardWithShadow theme-card" style="flex: 1;  min-width: 350px;">
        <mat-card-header>
            <mat-card-title class="m-b-0">Pressures</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="col-md-12"
                *ngIf="order?.dynamicPressureFilesAccount > 0 || order?.staticPressureFilesAccount > 0">
                <div class="card rounded-5">
                    <div class="card-body">
                        <h4 class="card-title">Pressures</h4>
                        <div class="card-body">
                            <div class="flex-container">
                                <span *ngFor="let file of order.files | filterByPressureType">
                                    {{file.path}}
                                </span>
                                <app-pressure-map *ngFor="let file of order.files | filterByPressureType"
                                    [jsonUrl]='file.path' [orderData]="order?.data">
                                </app-pressure-map>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div> -->


<div style="width: 1400px !important;" *ngIf="PDFDetailsVisible">

    <app-analysis-details-report-pdf
        (PDFGenerationComplete)="onPDFGenerationComplete()"></app-analysis-details-report-pdf>

</div>